import styled, { css } from 'react-emotion';
import Title from '../../Symbols/Title';

export const Suggester = styled.div`
	margin-bottom: 1rem;

	${Title} {
		line-height: 3;
		margin-bottom: 0.25rem;
	}

	img {
		margin-right: 1rem;
		vertical-align: middle;
	}
`;

export const Theme = {
	container: css`
		font-size: 0.875rem;
		position: relative;
		text-align: left;
		width: 300px;

		@media (max-width: 374px) {
			width: 100%;
		}
	`,
	input: css`
		border: 1px solid #999;
		box-sizing: border-box;
		color: inherit;
		font-size: inherit;
		line-height: 2;
		padding: 0 0.5rem;
		outline: none;
		width: 100%;
	`,
	suggestionsContainer: css`
		background: white;
		box-sizing: border-box;
		line-height: 2;
		position: absolute;
		width: 100%;
	`,
	suggestionsContainerOpen: css`
		border: 1px solid #999;
		border-top: 0;
	`,
	suggestionsList: css`
		list-style: none;
		margin: 0;
		padding: 0;
	`,
	suggestion: css`
		border-top: 1px solid #eee;
		cursor: pointer;
		padding: 0 0.25rem;
	`,
	suggestionFirst: css`
		border-top: 0;
	`,
	suggestionHighlighted: css`
		background: rgba(4, 133, 165, 0.1);
	`
};
